import React from "react";
import "../css/delivery.scss";

function Delivery() {
  return (
    <div className="shipping-page">
      <div className="container">
        <h1>Shipping</h1>
        <div className="content-section">
          <p className="intro">
            We're just as excited about your order as you are!
          </p>
          <p>
            We aim to get your order shipped off as soon as possible. During
            peak periods or unforeseen delays, dispatch times may be slightly
            extended. If this happens, we will keep you informed.
          </p>
          <p>
            Shipping is charged at a flat rate of <strong>$9.99 USD</strong> per
            order. The full order total is shown before you continue to payment.
          </p>
          <p>
            Estimated delivery timeframes vary by destination and are provided
            with your dispatch confirmation. Remote-area delivery may take longer.
          </p>
          <p>
            Please ensure your shipping details are correct at checkout, as we
            are unable to take responsibility for incorrect addresses and
            additional charges may apply for redelivery. Due to our fast
            processing times, we may not be able to combine multiple orders.
          </p>
          <p>
            Once your order has been dispatched, you will receive tracking
            details via email.
          </p>
          <p>
            If you have any questions regarding shipping, please contact us at{" "}
            <a href="mailto:import@cewillowmarket.life">
              import@cewillowmarket.life
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Delivery;
